import { PostData } from "@web/types/blog/PostData";
import styles from "./css/BlogPostTile.module.css";
import { AspectRatioContainer, Body1, Body2Medium, ColorClass } from "ui";
import { dayjsex } from "@web/utils/dates/dayjsex";
import Link from "next/link";
import Image from "next/image";

type Props = {
  postData: PostData;
};

export function BlogPostTile({ postData }: Props) {
  return (
    <Link
      className={styles.container}
      href={`/blog/${postData.id}`}
      style={{ textDecoration: "none" }}
    >
      <AspectRatioContainer width={16} height={7}>
        <Image
          alt={postData.title}
          className={styles.image}
          fill
          src={postData.src}
        />
      </AspectRatioContainer>
      <div className={styles.content}>
        <Body2Medium colorClass={ColorClass.Highlight}>
          {dayjsex(postData.date).format("M/D/YY")}
        </Body2Medium>
        <h2 className={styles.title}>{postData.title}</h2>
        <Body1 className={styles.summary} colorClass={ColorClass.Primary}>
          {postData.summary}
        </Body1>
      </div>
    </Link>
  );
}
